/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ApiReportDownloadPostRequest } from "../models";
// @ts-ignore
import { CodeNameRecord } from "../models";
// @ts-ignore
import { FileUriODataResultCollection } from "../models";
/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [cardCode]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportARAgingStatementFileGet: async (
      cardCode?: string,
      startDate?: string,
      endDate?: string,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/ARAgingStatementFile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (cardCode !== undefined) {
        localVarQueryParameter["CardCode"] = cardCode;
      }

      if (startDate !== undefined) {
        localVarQueryParameter["StartDate"] =
          (startDate as any) instanceof Date
            ? (startDate as any).toISOString()
            : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter["EndDate"] =
          (endDate as any) instanceof Date
            ? (endDate as any).toISOString()
            : endDate;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [docEntry]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportBillOfLadingFileGet: async (
      docEntry?: number,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/BillOfLadingFile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (docEntry !== undefined) {
        localVarQueryParameter["DocEntry"] = docEntry;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} cardCode
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportCardCodeGetFileUriListGet: async (
      cardCode: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'cardCode' is not null or undefined
      assertParamExists(
        "apiReportCardCodeGetFileUriListGet",
        "cardCode",
        cardCode
      );
      const localVarPath = `/api/Report/{CardCode}/GetFileUriList`.replace(
        `{${"CardCode"}}`,
        encodeURIComponent(String(cardCode))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [contractNumber]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportContractConfirmationFileGet: async (
      contractNumber?: number,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/ContractConfirmationFile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (contractNumber !== undefined) {
        localVarQueryParameter["ContractNumber"] = contractNumber;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [contractNumber]
     * @param {string} [endDate]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportContractStatementFileGet: async (
      contractNumber?: number,
      endDate?: string,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/ContractStatementFile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (contractNumber !== undefined) {
        localVarQueryParameter["ContractNumber"] = contractNumber;
      }

      if (endDate !== undefined) {
        localVarQueryParameter["EndDate"] =
          (endDate as any) instanceof Date
            ? (endDate as any).toISOString()
            : endDate;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ApiReportDownloadPostRequest} [apiReportDownloadPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportDownloadPost: async (
      apiReportDownloadPostRequest?: ApiReportDownloadPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/Download`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiReportDownloadPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ApiReportDownloadPostRequest} [apiReportDownloadPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportGetValidRecipientsPost: async (
      apiReportDownloadPostRequest?: ApiReportDownloadPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/GetValidRecipients`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiReportDownloadPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [docEntry]
     * @param {number} [objType]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportInvoiceFileGet: async (
      docEntry?: number,
      objType?: number,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/InvoiceFile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (docEntry !== undefined) {
        localVarQueryParameter["DocEntry"] = docEntry;
      }

      if (objType !== undefined) {
        localVarQueryParameter["ObjType"] = objType;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ApiReportDownloadPostRequest} [apiReportDownloadPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportSendEmailPost: async (
      apiReportDownloadPostRequest?: ApiReportDownloadPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Report/SendEmail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiReportDownloadPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [cardCode]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportARAgingStatementFileGet(
      cardCode?: string,
      startDate?: string,
      endDate?: string,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportARAgingStatementFileGet(
          cardCode,
          startDate,
          endDate,
          format,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} [docEntry]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportBillOfLadingFileGet(
      docEntry?: number,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportBillOfLadingFileGet(
          docEntry,
          format,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} cardCode
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportCardCodeGetFileUriListGet(
      cardCode: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FileUriODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportCardCodeGetFileUriListGet(
          cardCode,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} [contractNumber]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportContractConfirmationFileGet(
      contractNumber?: number,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportContractConfirmationFileGet(
          contractNumber,
          format,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} [contractNumber]
     * @param {string} [endDate]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportContractStatementFileGet(
      contractNumber?: number,
      endDate?: string,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportContractStatementFileGet(
          contractNumber,
          endDate,
          format,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {ApiReportDownloadPostRequest} [apiReportDownloadPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportDownloadPost(
      apiReportDownloadPostRequest?: ApiReportDownloadPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportDownloadPost(
          apiReportDownloadPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {ApiReportDownloadPostRequest} [apiReportDownloadPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportGetValidRecipientsPost(
      apiReportDownloadPostRequest?: ApiReportDownloadPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CodeNameRecord>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportGetValidRecipientsPost(
          apiReportDownloadPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} [docEntry]
     * @param {number} [objType]
     * @param {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportInvoiceFileGet(
      docEntry?: number,
      objType?: number,
      format?:
        | "None"
        | "ATOM"
        | "CSV"
        | "EXCEL"
        | "EXCELOPENXML"
        | "HTML4"
        | "HTML5"
        | "IMAGE"
        | "MHTML"
        | "PDF"
        | "PPTX"
        | "WORD"
        | "WORDOPENXML"
        | "XML",
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportInvoiceFileGet(
          docEntry,
          objType,
          format,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {ApiReportDownloadPostRequest} [apiReportDownloadPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportSendEmailPost(
      apiReportDownloadPostRequest?: ApiReportDownloadPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportSendEmailPost(
          apiReportDownloadPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ReportApiFp(configuration);
  return {
    /**
     *
     * @param {ReportApiApiReportARAgingStatementFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportARAgingStatementFileGet(
      requestParameters: ReportApiApiReportARAgingStatementFileGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiReportARAgingStatementFileGet(
          requestParameters.cardCode,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.format,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportBillOfLadingFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportBillOfLadingFileGet(
      requestParameters: ReportApiApiReportBillOfLadingFileGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiReportBillOfLadingFileGet(
          requestParameters.docEntry,
          requestParameters.format,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportCardCodeGetFileUriListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportCardCodeGetFileUriListGet(
      requestParameters: ReportApiApiReportCardCodeGetFileUriListGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FileUriODataResultCollection> {
      return localVarFp
        .apiReportCardCodeGetFileUriListGet(
          requestParameters.cardCode,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportContractConfirmationFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportContractConfirmationFileGet(
      requestParameters: ReportApiApiReportContractConfirmationFileGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiReportContractConfirmationFileGet(
          requestParameters.contractNumber,
          requestParameters.format,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportContractStatementFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportContractStatementFileGet(
      requestParameters: ReportApiApiReportContractStatementFileGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiReportContractStatementFileGet(
          requestParameters.contractNumber,
          requestParameters.endDate,
          requestParameters.format,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportDownloadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportDownloadPost(
      requestParameters: ReportApiApiReportDownloadPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiReportDownloadPost(
          requestParameters.apiReportDownloadPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportGetValidRecipientsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportGetValidRecipientsPost(
      requestParameters: ReportApiApiReportGetValidRecipientsPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<CodeNameRecord>> {
      return localVarFp
        .apiReportGetValidRecipientsPost(
          requestParameters.apiReportDownloadPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportInvoiceFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportInvoiceFileGet(
      requestParameters: ReportApiApiReportInvoiceFileGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiReportInvoiceFileGet(
          requestParameters.docEntry,
          requestParameters.objType,
          requestParameters.format,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportApiApiReportSendEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportSendEmailPost(
      requestParameters: ReportApiApiReportSendEmailPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiReportSendEmailPost(
          requestParameters.apiReportDownloadPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiReportARAgingStatementFileGet operation in ReportApi.
 * @export
 * @interface ReportApiApiReportARAgingStatementFileGetRequest
 */
export interface ReportApiApiReportARAgingStatementFileGetRequest {
  /**
   *
   * @type {string}
   * @memberof ReportApiApiReportARAgingStatementFileGet
   */
  readonly cardCode?: string;

  /**
   *
   * @type {string}
   * @memberof ReportApiApiReportARAgingStatementFileGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof ReportApiApiReportARAgingStatementFileGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'}
   * @memberof ReportApiApiReportARAgingStatementFileGet
   */
  readonly format?:
    | "None"
    | "ATOM"
    | "CSV"
    | "EXCEL"
    | "EXCELOPENXML"
    | "HTML4"
    | "HTML5"
    | "IMAGE"
    | "MHTML"
    | "PDF"
    | "PPTX"
    | "WORD"
    | "WORDOPENXML"
    | "XML";
}

/**
 * Request parameters for apiReportBillOfLadingFileGet operation in ReportApi.
 * @export
 * @interface ReportApiApiReportBillOfLadingFileGetRequest
 */
export interface ReportApiApiReportBillOfLadingFileGetRequest {
  /**
   *
   * @type {number}
   * @memberof ReportApiApiReportBillOfLadingFileGet
   */
  readonly docEntry?: number;

  /**
   *
   * @type {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'}
   * @memberof ReportApiApiReportBillOfLadingFileGet
   */
  readonly format?:
    | "None"
    | "ATOM"
    | "CSV"
    | "EXCEL"
    | "EXCELOPENXML"
    | "HTML4"
    | "HTML5"
    | "IMAGE"
    | "MHTML"
    | "PDF"
    | "PPTX"
    | "WORD"
    | "WORDOPENXML"
    | "XML";
}

/**
 * Request parameters for apiReportCardCodeGetFileUriListGet operation in ReportApi.
 * @export
 * @interface ReportApiApiReportCardCodeGetFileUriListGetRequest
 */
export interface ReportApiApiReportCardCodeGetFileUriListGetRequest {
  /**
   *
   * @type {string}
   * @memberof ReportApiApiReportCardCodeGetFileUriListGet
   */
  readonly cardCode: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof ReportApiApiReportCardCodeGetFileUriListGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof ReportApiApiReportCardCodeGetFileUriListGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof ReportApiApiReportCardCodeGetFileUriListGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof ReportApiApiReportCardCodeGetFileUriListGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiReportContractConfirmationFileGet operation in ReportApi.
 * @export
 * @interface ReportApiApiReportContractConfirmationFileGetRequest
 */
export interface ReportApiApiReportContractConfirmationFileGetRequest {
  /**
   *
   * @type {number}
   * @memberof ReportApiApiReportContractConfirmationFileGet
   */
  readonly contractNumber?: number;

  /**
   *
   * @type {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'}
   * @memberof ReportApiApiReportContractConfirmationFileGet
   */
  readonly format?:
    | "None"
    | "ATOM"
    | "CSV"
    | "EXCEL"
    | "EXCELOPENXML"
    | "HTML4"
    | "HTML5"
    | "IMAGE"
    | "MHTML"
    | "PDF"
    | "PPTX"
    | "WORD"
    | "WORDOPENXML"
    | "XML";
}

/**
 * Request parameters for apiReportContractStatementFileGet operation in ReportApi.
 * @export
 * @interface ReportApiApiReportContractStatementFileGetRequest
 */
export interface ReportApiApiReportContractStatementFileGetRequest {
  /**
   *
   * @type {number}
   * @memberof ReportApiApiReportContractStatementFileGet
   */
  readonly contractNumber?: number;

  /**
   *
   * @type {string}
   * @memberof ReportApiApiReportContractStatementFileGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'}
   * @memberof ReportApiApiReportContractStatementFileGet
   */
  readonly format?:
    | "None"
    | "ATOM"
    | "CSV"
    | "EXCEL"
    | "EXCELOPENXML"
    | "HTML4"
    | "HTML5"
    | "IMAGE"
    | "MHTML"
    | "PDF"
    | "PPTX"
    | "WORD"
    | "WORDOPENXML"
    | "XML";
}

/**
 * Request parameters for apiReportDownloadPost operation in ReportApi.
 * @export
 * @interface ReportApiApiReportDownloadPostRequest
 */
export interface ReportApiApiReportDownloadPostRequest {
  /**
   *
   * @type {ApiReportDownloadPostRequest}
   * @memberof ReportApiApiReportDownloadPost
   */
  readonly apiReportDownloadPostRequest?: ApiReportDownloadPostRequest;
}

/**
 * Request parameters for apiReportGetValidRecipientsPost operation in ReportApi.
 * @export
 * @interface ReportApiApiReportGetValidRecipientsPostRequest
 */
export interface ReportApiApiReportGetValidRecipientsPostRequest {
  /**
   *
   * @type {ApiReportDownloadPostRequest}
   * @memberof ReportApiApiReportGetValidRecipientsPost
   */
  readonly apiReportDownloadPostRequest?: ApiReportDownloadPostRequest;
}

/**
 * Request parameters for apiReportInvoiceFileGet operation in ReportApi.
 * @export
 * @interface ReportApiApiReportInvoiceFileGetRequest
 */
export interface ReportApiApiReportInvoiceFileGetRequest {
  /**
   *
   * @type {number}
   * @memberof ReportApiApiReportInvoiceFileGet
   */
  readonly docEntry?: number;

  /**
   *
   * @type {number}
   * @memberof ReportApiApiReportInvoiceFileGet
   */
  readonly objType?: number;

  /**
   *
   * @type {'None' | 'ATOM' | 'CSV' | 'EXCEL' | 'EXCELOPENXML' | 'HTML4' | 'HTML5' | 'IMAGE' | 'MHTML' | 'PDF' | 'PPTX' | 'WORD' | 'WORDOPENXML' | 'XML'}
   * @memberof ReportApiApiReportInvoiceFileGet
   */
  readonly format?:
    | "None"
    | "ATOM"
    | "CSV"
    | "EXCEL"
    | "EXCELOPENXML"
    | "HTML4"
    | "HTML5"
    | "IMAGE"
    | "MHTML"
    | "PDF"
    | "PPTX"
    | "WORD"
    | "WORDOPENXML"
    | "XML";
}

/**
 * Request parameters for apiReportSendEmailPost operation in ReportApi.
 * @export
 * @interface ReportApiApiReportSendEmailPostRequest
 */
export interface ReportApiApiReportSendEmailPostRequest {
  /**
   *
   * @type {ApiReportDownloadPostRequest}
   * @memberof ReportApiApiReportSendEmailPost
   */
  readonly apiReportDownloadPostRequest?: ApiReportDownloadPostRequest;
}

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
  /**
   *
   * @param {ReportApiApiReportARAgingStatementFileGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportARAgingStatementFileGet(
    requestParameters: ReportApiApiReportARAgingStatementFileGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportARAgingStatementFileGet(
        requestParameters.cardCode,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.format,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportBillOfLadingFileGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportBillOfLadingFileGet(
    requestParameters: ReportApiApiReportBillOfLadingFileGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportBillOfLadingFileGet(
        requestParameters.docEntry,
        requestParameters.format,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportCardCodeGetFileUriListGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportCardCodeGetFileUriListGet(
    requestParameters: ReportApiApiReportCardCodeGetFileUriListGetRequest,
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportCardCodeGetFileUriListGet(
        requestParameters.cardCode,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportContractConfirmationFileGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportContractConfirmationFileGet(
    requestParameters: ReportApiApiReportContractConfirmationFileGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportContractConfirmationFileGet(
        requestParameters.contractNumber,
        requestParameters.format,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportContractStatementFileGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportContractStatementFileGet(
    requestParameters: ReportApiApiReportContractStatementFileGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportContractStatementFileGet(
        requestParameters.contractNumber,
        requestParameters.endDate,
        requestParameters.format,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportDownloadPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportDownloadPost(
    requestParameters: ReportApiApiReportDownloadPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportDownloadPost(
        requestParameters.apiReportDownloadPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportGetValidRecipientsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportGetValidRecipientsPost(
    requestParameters: ReportApiApiReportGetValidRecipientsPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportGetValidRecipientsPost(
        requestParameters.apiReportDownloadPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportInvoiceFileGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportInvoiceFileGet(
    requestParameters: ReportApiApiReportInvoiceFileGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportInvoiceFileGet(
        requestParameters.docEntry,
        requestParameters.objType,
        requestParameters.format,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportApiApiReportSendEmailPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */
  public apiReportSendEmailPost(
    requestParameters: ReportApiApiReportSendEmailPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ReportApiFp(this.configuration)
      .apiReportSendEmailPost(
        requestParameters.apiReportDownloadPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
